/**
 * 登录模块
 **/

import {
    CHANGE_FORGOT_PASSWORD_MODAL,
    CHANGE_LOGIN_MODAL,
    CHANGE_REGISTER_MODAL,
    SET_USER_INFO, SET_USER_INFO_PROMISE
} from "@constants/mutation-type/login-mutation-type";
import {INIT_USER_INFO} from "@constants/action-type/login-action-type";
import {getUserInfo} from "@api/personal-api";

export default {
    namespaced: true,
    state: {
        isLogin: false,
        userInfo: {},
        showLoginModal: false,
        showRegisterModal: false,
        showForgotPasswordModal: false,
    },
    getters: {},
    mutations: {
        [SET_USER_INFO](state, payload) {
            state.isLogin = payload.isLogin;
            console.log(payload.userInfo)
            state.userInfo = payload.userInfo || {};
        },
        [SET_USER_INFO_PROMISE](state, {userInfoPromise}) {
            state.userInfoPromise = userInfoPromise;
        },
        [CHANGE_LOGIN_MODAL](state, payload) {
            state.showLoginModal = payload.showLoginModal;
        },
        [CHANGE_REGISTER_MODAL](state, payload) {
            state.showRegisterModal = payload.showRegisterModal;
        },
        [CHANGE_FORGOT_PASSWORD_MODAL](state, payload) {
            state.showForgotPasswordModal = payload.showForgotPasswordModal;
        },
    },
    actions: {
        [INIT_USER_INFO]({commit}) {
            return getUserInfo().then(res => {
                const payload = {
                    isLogin: false,
                    userInfo: {}
                };
                console.log(res)
                if (res.code === 0) {
                    payload.isLogin = true;
                    payload.userInfo = res.data;
                }
                commit(SET_USER_INFO, payload);
                return res;
            })
        },
    }
}
